import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { apiService } from "../../services/apiService";
import { constructCoachPath, getImagePath } from "../../services/commonService";
import ImageWithOutBasePath from "../../core/data/img/ImageWithOutBasePath";

const CoachesGrid = () => {
  const routes = all_routes;
  const [selectedItems, setSelectedItems] = useState(Array(9).fill(false));
  const { locationId } = useParams<{ locationId: string }>();
  const handleItemClick = (index: number) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      updatedSelectedItems[index] = !updatedSelectedItems[index];
      return updatedSelectedItems;
    });
  };
  const [data, setData] = useState<any | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    setTimeout(() => {
      apiService
        .get('/api/v1/coaches?location='+locationId)
        .then((response) => setData(response))
        .catch((err) => setError(err.message));
    }, 1000);
  }, []);
  const sortOptions = [{ name: "Relevance" }, { name: "Price" }];
  const [selectedSort, setSelectedSort] = useState();

  return (
    <div>
      {/* Breadcrumb */}
      <section className="breadcrumb breadcrumb-list mb-0">
        <span className="primary-right-round" />
        <div className="container">
          <h1 className="text-white">Coaches</h1>
          <ul>
            <li>
              <Link to={routes.home}>Home</Link>
            </li>
            <li>Coaches</li>
          </ul>
        </div>
      </section>
      {/* /Breadcrumb */}
      {/* Page Content */}
      <div className="content">
        <div className="container">
          <div className="row justify-content-center">
            {/* Featured Item */}

            {Array.isArray(data?.data) && data.data.length > 0 ? (
              data.data.map((coach: any) => (
                <div key={coach.id} className="col-lg-4 col-md-6">
                  <div className="featured-venues-item">
                    <div className="listing-item listing-item-grid">
                      <div className="listing-img">
                        <Link to={constructCoachPath(coach)}>
                          <ImageWithOutBasePath
                            src={getImagePath(coach.avatar)}
                            alt="Venue"
                          />
                        </Link>
                        <div className="fav-item-venues" key={coach.id} onClick={() => handleItemClick(coach.id)}>
                          {coach.verified ? (
                            <span className="tag tag-blue">Verified</span>
                          ) : <span></span>}
                          <div className="d-flex align-items-center">
                            <span className="rating-bg">{(parseFloat(coach.rating)).toFixed(1)}</span>
                            <span>{coach.review_count} Reviews</span>
                          </div>

                        </div>
                        <div className="hour-list">
                          <h5 className="tag tag-primary">
                            From ${coach.coach_fee} <span>/hr</span>
                          </h5>
                        </div>
                      </div>
                      <div className="listing-content">
                        <div className="grid-item-content">
                          <h3 className="listing-title">
                            <Link to={constructCoachPath(coach)}>{coach.first_name} {coach.last_name}</Link>
                          </h3>
                          <ul className="mb-2">
                            {coach.location ? (

                              <li>
                                <span>
                                  <i className="feather-map-pin me-2" />
                                  {coach.location.name}
                                </span>
                              </li>
                            ) : ''}
                            <li>

                            </li>
                          </ul>


                          <div className="listing-details-group">
                            <p>
                              {coach.description}
                            </p>
                          </div>
                        </div>
                        <div className="coach-btn">
                          <ul>
                            <li>
                              <Link
                                to={constructCoachPath(coach)}
                                className="btn btn-primary w-100"
                              >
                                <i className="feather-eye me-2" />
                                View Profile
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`${routes.bookingType}/coach/location/${locationId}/time&date`}
                                className="btn btn-secondary w-100"
                              >
                                <i className="feather-calendar me-2" />
                                Book Now
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : 'No coaches found for this location.'}


            {/* /Featured Item */}
            {/* <div className="col-12 text-center mt-3">
              <Link to="#" className="btn btn-load">
                Load More Coaches{" "}
                <ImageWithBasePath
                  src="assets/img/icons/u_plus-square.svg"
                  className="ms-2"
                  alt="Icon"
                />
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </div>
  );
};

export default CoachesGrid;
